import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// import store from '@/store'
import { getToken } from '@/utils/auth'
import configs from '@/configs'
import stateCode from './stateCode'
import { removeToken } from './auth'


const common = {
  baseURL: configs.API_SERVER,
  headers: {},
  timeout: 10000
}

// request interceptor
axios.interceptors.request.use(config => {
  // Do something before request is sent
  if (getToken()) {
    config.headers['X-Access-Token'] = getToken() // 让每个请求携带token-- ['X-Access-Token']为自定义key 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
axios.interceptors.response.use(
  response => {
    const res = response.data
    // 1002:Token 过期了;
    if (res.code === stateCode.signError) {
      // alert( res.code)
      Message({
        message: res.msg,
        type: 'error',
        duration: 2*1000,
        onClose: MessageBoxFn
      });
      return Promise.reject('error')
    } else {
      return res
    }
  },
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */

  err => {
    console.log('err', err);
    // Do something with response error
    if (err.response && err.response.data) {
      const error = err.response.data
      return Promise.reject(error)
    } else {
      const message = '网络错误, 请尝试刷新!'
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(message))
    }
  }
)

function MessageBoxFn () {
  MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
    confirmButtonText: '重新登录',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    // 清除 token
    removeToken();
    let originUrl = `${configs.HOST}&toolsId=${configs.TOOLS_ID}`;
    location.replace(configs.MASTER_WEB_URL + '/public-login?oauth_callback=' + originUrl)
  })
}

// create an axios instance
const service = axios.create({})

/**
 * GET 用户查询
 * @param url
 * @param filters
 * @returns {AxiosPromise}
 */
service.get = function (url, filters) {
  const cb = arguments[arguments.length - 1]
  if (typeof cb === 'function') {
    axios({
      method: 'get',
      url: url,
      params: filters,
      ...common
    }).then(function (result) {
      cb(null, result)
    }).catch(function (err) {
      cb(err, null)
    })
  } else {
    return axios({
      method: 'get',
      url: url,
      params: filters,
      ...common
    })
  }
}

/**
 * POST 用户登录, 创建/保存
 * @param url
 * @param data
 * @returns {AxiosPromise}
 */
service.post = function (url, data) {
  const cb = arguments[arguments.length - 1]
  if (typeof cb === 'function') {
    axios({
      method: 'post',
      url: url,
      data: data,
      ...common
    }).then(function (result) {
      cb(null, result)
    }).catch(function (err) {
      cb(err, null)
    })
  } else {
    return axios({
      method: 'post',
      url: url,
      data: data,
      ...common
    })
  }
}

/**
 * PUT 用于更新
 * @param url
 * @param data
 * @returns {AxiosPromise}
 */
service.put = function (url, data) {
  const cb = arguments[arguments.length - 1]
  if (typeof cb === 'function') {
    axios({
      method: 'put',
      url: url + data.id,
      data: data,
      ...common
    }).then(function (result) {
      cb(null, result)
    }).catch(function (err) {
      cb(err, null)
    })
  } else {
    return axios({
      method: 'put',
      url: url + data.id,
      data: data,
      ...common
    })
  }
}

/**
 * DELETE 用于删除
 * @param url
 * @param id
 * @returns {AxiosPromise}
 */
service.delete = function (url, id) {
  const cb = arguments[arguments.length - 1]
  if (typeof cb === 'function') {
    axios({
      method: 'delete',
      url: url + id,
      ...common
    }).then(function (result) {
      cb(null, result)
    }).catch(function (err) {
      cb(err, null)
    })
  } else {
    return axios({
      method: 'delete',
      url: url + id,
      ...common
    })
  }
}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js